import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TellentPosition } from '@core/tellent-positions-types';

@Component({
  selector: 'tlc-position-details-skills',
  template: `details-skills`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PositionDetailsSkillsComponent {
  public readonly positionData = input.required<TellentPosition | null>();
}
